<template>
    <div>
     <s-button 
            @onclick="setDemoTuto"
            :label="$store.getters.getDemo.admin ? 'TUTO ADMIN ON' : 'TUTO ADMIN OFF'"
            :theme="$store.getters.getDemo.admin ? 'is-success' : 'is-warning'"
    />&nbsp;
   
    <div v-if="configure!=null">
                <h1> Liste des tutos à configurer </h1>
                <s-button @onclick="tutoDatas=null" label="Liste des tutos" theme="is-dark is-small" icon="list"/>&nbsp;
                <s-button @onclick="addModalAddTutoriel" label="Ajouter un tutoriel" theme="is-success is-small" icon="plus"/>
                <s-modal
                        :open="modalAddTutoriel"
                        :close="true"
                        @close="modalAddTutoriel=false;tutoDatas=null"
                        @save="saveAddTutoriel"
                        :save="true"
                    >
                Id du tutotiel : 
                <s-input type='text' v-model="addTutorielId" theme="is-danger"/>
                Libelle du tutoriel : 
                <s-input type='text' v-model="addTutorielTxt" theme="is-danger"/>
                Id du club à copier :
                <s-input type='text' v-model="idClubCopy" theme="is-danger"/>
                </s-modal>
                <div v-for="tutorial in AllTutoDatas" v-if="tutoDatas==null" class="tutoItem">
                    <div class="tutorialItem">{{tutorial.id}}</div>
                    <div class="tutorialItem">{{tutorial.label}} </div>
                    <s-button @onclick="editTutorial(tutorial.id)" label="Editer" theme="is-warning is-small"/>&nbsp;
                    <s-button @onclick="selectTuto(tutorial.id)" label="Admnistrer" theme="is-small"/>&nbsp;
                    <s-button @onclick="deleteTutorial(tutorial.id)" label="Supprimer" theme="is-danger is-small"/>&nbsp;
                    <s-button @onclick="exportTuto(tutorial.id)" icon="file-excel" label="Exporter" theme=""/>
                    <s-button @onclick="importTuto(tutorial.id)" icon="upload" label="Importer" theme=""/>
                </div>
                <div v-if="tutoDatas!=null  ">
                <s-button icon="undo" theme="is-dark" label=""  @onclick="tutoDatas=null" />&nbsp;&nbsp;
                <s-button icon="plus" theme="is-success" label=""  @onclick="setTuto()" /><hr/>
                {{tutoDatas.id}}</hr>
                <table border="1" v-if="tutoDatas">
                <tr v-for="(tutoItem, index) in tutoDatas.data">
                    <td><s-button label=""  @onclick="up(index)" icon="arrow-up" v-if="index>0"/></td>
                    <td><s-button label="" @onclick="down(index)" icon="arrow-down" v-if="index<tutoDatas.data.length-1"/></td>
                    <td>{{index}}</td>
                    <td>{{tutoItem.id}} ({{tutoItem.byId}})</td>
                    <td>{{tutoItem.route}}</td>
                    <td>{{tutoItem.inc}}</td>
                    <td>{{tutoItem.pred}} <s-button @onclick="incAllPred(index)" label="" icon="angle-double-down"/> </td>
                    <td><s-button @onclick="deleteTuto(index)" icon="trash" label="" theme="is-danger"/></td>
                    <td><s-button @onclick="editTuto(tutoItem, index)" icon="edit" label="" theme="is-warning"/></td>
                    <td><s-button @onclick="paramTuto(tutoItem, index)" icon="cog" label="" theme="is-black"/></td>
                   
                </tr>
                </table>
                <s-modal
                :open="modalParam"
                :close="true"
                @close="modalParam=false"
                @save="saveParam()"
                :save="true"
            >
                <div v-if="tutoDatas!=null && indexSelectedTuto!=null && tutoDatas.data.length>0">
                Revenir en arriere:
                    <s-switch id="back" @change="tutoDatas.data[indexSelectedTuto].back=!tutoDatas.data[indexSelectedTuto].back" 
                        :defaultState="tutoDatas.data[indexSelectedTuto].back" 
                        labelEnableText="OUI" 
                        labelDisableText="NON"/>
                    <div v-if="tutoDatas.data[indexSelectedTuto].back">
                        Aller à <input type="numer" v-model="tutoDatas.data[indexSelectedTuto].returnTo"/>
                    </div>
                <br/>
                    Augmenter de :
                    <input type="number" v-model="tutoDatas.data[indexSelectedTuto].inc"/>
                <br/>
                    Predecesseur :
                    <input type="number" v-model="tutoDatas.data[indexSelectedTuto].pred"/>
                Score :
                    <s-switch id="score" @change="tutoDatas.data[indexSelectedTuto].score=!tutoDatas.data[indexSelectedTuto].score" 
                        :defaultState="tutoDatas.data[this.indexSelectedTuto].score" 
                        labelEnableText="OUI" 
                        labelDisableText="NON"/>
                        <br/>
                         Equipe :
                    <s-switch id="Equipe" @change="tutoDatas.data[indexSelectedTuto].equipe=!tutoDatas.data[indexSelectedTuto].equipe" 
                        :defaultState="tutoDatas.data[this.indexSelectedTuto].equipe" 
                        labelEnableText="OUI" 
                        labelDisableText="NON"/>
                <br/>
                
                Mettre tout en haut (en mobile):
                    <s-switch id="mobile" @change="tutoDatas.data[indexSelectedTuto].top=!tutoDatas.data[indexSelectedTuto].top" 
                        :defaultState="tutoDatas.data[indexSelectedTuto].top" 
                        labelEnableText="OUI" 
                        labelDisableText="NON"/>
                </div>
            </s-modal>
            <s-modal 
                :open="addTuto"
                :close="true"
                @close="addTuto=false"
                :save="tutoDatas.data.length==0"
                @save="addFirstTuto"
            >
                {{tutoDatas.data}}
                <div v-if="tutoDatas.data.length>0">
                    <s-button :icon="tutoDatas.record ? 'video' : 'stop'" label="Recorder" @onclick="setRecorder" theme="is-warning"/>&nbsp;
                </div>
                <div v-if="tutoDatas.data.length==0">
                    <s-input v-model="viewModel" theme="is-primary"/>
                </div>
            </s-modal>
         
             <s-modal
                :open="modalEditor"
                :close="true"
                @close="modalEditor=false;"
                @save="saveEditor"
                :save="true"
                :deleteData="true"
                @delete="deleteEditor"
                title="Editer le tuto"
            >
                <div >
                <quill-editor v-model="textTuto"
                    ref="myQuillEditor"
                    :options="editorOption"
                    :disabled="false"
                    >
                </quill-editor>
                </div>
                <div class="ql-editor"  v-html="textTuto">
                </div>
            </s-modal>
                </div>
            </div>    
             <s-modal
                :open="importModal"
                :close="true"
                @close="importModal=false"
                title="Importation "
            >
                <div>
                    <upload-excel-component 
                        :on-success="importLabelsXLS" 
                    />
                </div>
        </s-modal>
       
    </div>
</template>
<style scoped>
.table tr td {
    width: 50px
}
    .cancel {
        position: fixed;
        left: 10px;
        bottom: 10px;
    }
</style>


<style>

</style>
<style scoped>
    .tutoItem {
        width: 100%;
        margin-bottom: 10px;
        border: thin solid black;
        vertical-align: middle;
        padding: 10px;
    }
    .tuto {
        position: absolute;
        left: 20px;
        top: 200px;
        border: thin dashed black;
        background-color: aqua;
        padding: 10px;
        border-radius: 10px;
        color: black;
        padding-left: 5px;
    }
    .tutorialItem {
        display: inline-block;
        width: 200px;
        border: thin black solid;
    }
</style>
<script>
import tuto_api from '@/firebase/tuto_api'
import firebase_api from '@/firebase/firebase_api'
import UploadExcelComponent from '@/components/uploadXLS.vue'
import XLSX from 'xlsx'
export default {
    components: {
        UploadExcelComponent
    },
    data() {
        return {
            viewModel: null,
            modalAddTutoriel: false,
            importModal: false,
            addTutorielTxt: null,
            addTutorielId: null,
            idClubCopy: null,
            idClub: null,
            club: null,
            display: false,
            addTuto: false,
            tutoDatas: null,
            modalEditor: false,
            textTuto: '',
            modalParam: false,
            indexSelectedTuto: null,
            AllTutoDatas: [],
            choiceTuto: null,
            editorOption: {
                theme: 'snow',
                
                    modules: {
                        
                        toolbar: [
                    [{'size': ['small', false, 'large', 'huge']}],
                        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                        ['clean'], ['link'] 
                        ],
                        
                    }
            }
        }
    },
    computed: {
        configure: {
            get() {
                var demo = this.$store.getters.getDemo;
                return demo.admin;
            }
        }
    },
    watch: {
        $route(val) {
            if (val.name == 'club') {
                this.display = false;
                this.club = null;
                this.update(0);
            }
            else if (this.club == null)
                this.refresh();
            else {
                if (this.club.tuto==0 && val.name == 'membres')
                    this.update(1);
                else if (this.club.tuto==2 && val.name == 'concours')
                     this.update(3);
            }
            
        },
        tutoDatas(newVal, val) {
            /*if (val!=null)
            if (typeof(newVal)!="undefined" && typeof(val)!="undefined") {
                if (typeof(val.data)!="undefined") {
                if (newVal.data.length != val.data.length)
                    this.addTuto = false;
            }
            
            }*/
        }
    },
    methods: {
        addFirstTuto() {
            var addData = {
                back: false,
                byId: true,
                html: "",
                id: this.viewModel,
                route: this.viewModel,
                inc: "1",
                pred: "-1"
            }
            this.tutoDatas.data.push(addData);
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
        },
        incAllPred(index) {
            console.log(index);
            console.log(this.tutoDatas.data[index]);
            var valueOrigine = parseInt(this.tutoDatas.data[index].pred);
            console.log(valueOrigine);
            for (var i=index+1;i<this.tutoDatas.data.length;i++) {
                valueOrigine++;
                this.tutoDatas.data[i].pred = valueOrigine;
            }
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
        },
        importLabelsXLS(datas) {
           
            firebase_api.api.getDb().collection("tuto").doc(this.choiceTuto).update({
                data : datas.results
            }).then(()=>{
                this.importModal = false;
            })
        },
        addModalAddTutoriel() {
            this.choiceTuto = null;
            this.indexSelectedTuto = null;
            this.modalAddTutoriel = true;
        },
        editTutorial(id) {
            this.indexSelectedTuto = null;
            this.selectTuto(id, ()=>{
                
                this.addTutorielId = this.tutoDatas.id;
                this.addTutorielTxt = this.tutoDatas.label;
                this.idClubCopy = this.tutoDatas.idClubCopy;
                this.modalAddTutoriel = true;

            });
        },
        deleteTutorial(id) {
            if (confirm("Supprimer ?"))
                firebase_api.api.getDb().collection("tuto").doc(id).delete();
        },
        importTuto(id) {
            this.importModal = true;
            this.choiceTuto = id;
        },
        async exportTuto(id) {
            this.progress = true;
            var labelDoc = await firebase_api.api.getDb().collection("tuto").doc(id).get();
            var labels = [];
            if (labelDoc.exists) {
                var labelData = labelDoc.data();
                labelData.data.forEach((data, indiceData)=> {
                     labels.push(data);
                }) 
                var labelsXLS = XLSX.utils.json_to_sheet(labels)                
                var wb = XLSX.utils.book_new() // make Workbook of Excel
                // add Worksheet to Workbook
                // Workbook contains one or more worksheets
                XLSX.utils.book_append_sheet(wb, labelsXLS, id) // sheetAName is name of Worksheet
                // export Excel file
                XLSX.writeFile(wb, id+".xlsx") // name of the file is 'book.xlsx'
            }
        },
        saveAddTutoriel() {
            if (this.choiceTuto == null) {
                firebase_api.api.getDb().collection("tuto").doc(this.addTutorielId).set({
                    data: [],
                    label: this.addTutorielTxt,
                    idClubCopy: this.idClubCopy
                }).then(()=>{
                     this.tutoDatas = null;
                })
            }
            else {
                this.$firestoreRefs.tutoDatas.update({
                    label: this.addTutorielTxt,
                    idClubCopy: this.idClubCopy
                }).then(()=>{
                     this.tutoDatas = null;
                })
            }
        },
        up(index) {
            var element = JSON.parse(JSON.stringify(this.tutoDatas.data[index]));
            this.tutoDatas.data.splice(index-1, 0, element);
            this.tutoDatas.data.splice(index+1, 1);
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
        },
        down(index) {
            var indexP = parseInt(index)+1;
            var element = JSON.parse(JSON.stringify(this.tutoDatas.data[indexP]));
            this.tutoDatas.data.splice(indexP-1, 0, element);
            this.tutoDatas.data.splice(indexP+1, 1);
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
        },
        paramTuto(tutoItem, index) {
            this.modalParam = true;
            this.indexSelectedTuto = index;
        },
        saveParam() {
            if (typeof(this.tutoDatas.data[this.indexSelectedTuto].back)=="undefined") {
                this.tutoDatas.data[this.indexSelectedTuto].back=false;
                alert("ATTENTION BACK NON DEFINI")
            }
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
            this.modalParam = false;
        },
        editTuto(tutoItem, index) {
            this.textTuto = tutoItem.html;
            this.modalEditor = true;
            this.indexSelectedTuto = index;
        },
        saveEditor() {
            this.tutoDatas.data[this.indexSelectedTuto].html = this.textTuto;
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
        },
        deleteEditor() {

        },
        setDemoTuto() {
            var demoAdmin = !this.$store.getters.getDemo.admin;
            console.log(demoAdmin);
            this.$store.dispatch("setDemoAdmin", {admin: demoAdmin});
        },
        closeAdminTuto() {
            var demoAdmin = !this.$store.getters.getDemo.admin;
            console.log(demoAdmin);
            this.$store.dispatch("setDemoAdmin", {admin: demoAdmin});
        },
        deleteTuto(index) {
            this.tutoDatas.data.splice(index, 1);
            this.$firestoreRefs.tutoDatas.update({
                data: this.tutoDatas.data
            })
        },
        setRecorder() {
            if (this.tutoDatas.record)
                this.addTuto = false;
            this.$firestoreRefs.tutoDatas.update({
                record: !this.tutoDatas.record
            })
            
        },
        setTuto() {
            this.addTuto = true;
        },
        selectTuto(tuto, fct) {
            this.choiceTuto = tuto;
           
            this.$bind("tutoDatas", firebase_api.api.getDb().collection("tuto").doc(this.choiceTuto)).then(tuto=>{
                if (typeof(fct)!="undefined") 
                    fct();
            })
        },
    },
    mounted() {
        this.$bind("AllTutoDatas", firebase_api.api.getDb().collection("tuto"));
        
    }
}
</script>